import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { selectUser } from "../../redux/auth/selectors";
import { startCase } from "lodash";
import { USER_ACTIONS } from "../../redux/auth/actions";
import { Trans } from "react-i18next";

class _ProfileDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static propTypes = {
    user: PropTypes.object,
    updateUser: PropTypes.func,
    getUser: PropTypes.func
  };

  UNSAFE_componentWillMount() {
    this.props.getUser();
  }

  render() {
    const { user } = this.props;
    return (
      <form className="m-form m-form--fit m-form--label-align-right">
        <div className="m-portlet__body">
          {false && (
            <div className="form-group m-form__group m--margin-top-10 m--hide">
              <div className="alert m-alert m-alert--default" role="alert">
                The example form below demonstrates common HTML form elements
                that receive updated styles from Bootstrap with additional
                classes.
              </div>
            </div>
          )}

          <div className="form-group m-form__group row">
            <div className="col-10 ml-auto">
              <h3 className="m-form__section">Personal Details</h3>
            </div>
          </div>
          <div className="form-group m-form__group row">
            <label
              htmlFor="example-text-input"
              className="col-2 col-form-label"
            >
              <Trans>First Name</Trans>
            </label>
            <div className="col-7">
              <span className="profile-static">{user.firstName}</span>
            </div>
          </div>
          <div className="form-group m-form__group row">
            <label
              htmlFor="example-text-input"
              className="col-2 col-form-label"
            >
              <Trans>Last Name</Trans>
            </label>
            <div className="col-7">
              <span className="profile-static">{user.lastName}</span>
            </div>
          </div>
          <div className="form-group m-form__group row">
            <label
              htmlFor="example-text-input"
              className="col-2 col-form-label"
            >
              <Trans>Gender</Trans>
            </label>
            <div className="col-7">
              <span className="profile-static">{startCase(user.gender)}</span>
            </div>
          </div>
          <div className="form-group m-form__group row">
            <label
              htmlFor="example-text-input"
              className="col-2 col-form-label"
            >
              <Trans>Size</Trans>
            </label>
            <div className="col-7">
              <span className="profile-static">{user.size}</span>
              <span className="m-form__help">
                <Trans>
                  This is used to supply you with the correct T-shirt size if
                  needed.
                </Trans>
              </span>
            </div>
          </div>
          <div className="form-group m-form__group row">
            <label
              htmlFor="example-text-input"
              className="col-2 col-form-label"
            >
              <Trans>Phone No.</Trans>
            </label>
            <div className="col-7">
              <span className="profile-static">{user.telephone}</span>
            </div>
          </div>
          <div className="m-form__seperator m-form__seperator--dashed m-form__seperator--space-2x" />
          <div className="form-group m-form__group row">
            <div className="col-10 ml-auto">
              <h3 className="m-form__section">Account</h3>
            </div>
          </div>
          <div className="form-group m-form__group row">
            <label
              htmlFor="example-text-input"
              className="col-2 col-form-label"
            >
              <Trans>E-mail</Trans>
            </label>
            <div className="col-7">
              <span className="profile-static">{user.email}</span>
            </div>
          </div>
          <div className="form-group m-form__group row">
            <label
              htmlFor="example-text-input"
              className="col-2 col-form-label"
            >
              <Trans>Password</Trans>
            </label>
            <div className="col-7">
              <span className="profile-static">*****</span>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const mapStateToProps = function(state) {
  return {
    user: selectUser(state)
  };
};

const mapDispatchToProps = dispatch => ({
  getUser: () => dispatch(USER_ACTIONS.getDataRequest())
});

const ProfileDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(_ProfileDetails);

export default ProfileDetails;
